import { saveState } from './stateManagerHelper';
/**
 * Shuffle is a broadcast bottom-toolbar action: when N decks are selected together and Shuffle
 * is clicked once, EVERY selected deck's own CardManipulative instance has a listener for the
 * shared 'bottomPanel' event, and all of them run their 'suffle' handler synchronously in the
 * same dispatch loop (see customEvents.ts's dispatchEvent). Each deck computes and applies its
 * own shuffle independently (necessarily so — CardManipulative.tsx's `setManipulative(prev => ...)`
 * merge already handles that safely), but each was ALSO calling `saveState()` on its own, so
 * shuffling 2 selected decks in one click pushed 2 separate undo-history entries — one Undo only
 * reverted the deck whose entry landed last, not the whole action.
 *
 * This module collects every deck's shuffle entry from one dispatch tick and flushes them as a
 * SINGLE saveState() call (a deferred flush, not per-listener), so one Shuffle click always
 * produces exactly one undo/redo step regardless of how many decks were selected — mirroring
 * multiSelectSaveCoordinator.ts's flush pattern for drag gestures, but for a synchronous
 * broadcast-event action rather than a drag.
 */
var pendingEntries = [];
var flushTimeoutId = null;
function flush() {
    if (flushTimeoutId !== null) {
        clearTimeout(flushTimeoutId);
        flushTimeoutId = null;
    }
    if (pendingEntries.length > 0) {
        var entries = pendingEntries;
        pendingEntries = [];
        saveState(entries);
    }
}
/**
 * Call once per selected deck's shuffle, in place of a direct `saveState(entry)` call. Every
 * entry queued before the next microtask/timer tick (i.e. everything queued synchronously within
 * one 'bottomPanel' dispatch) is flushed together as one history entry.
 */
export function queueCardShuffleSaveEntry(entry) {
    pendingEntries.push(entry);
    if (flushTimeoutId === null) {
        flushTimeoutId = setTimeout(flush, 0);
    }
}
